var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('input',{ref:"flatpickr",staticClass:"form-control border w-100 bg-transparent",attrs:{"id":_vm.id_computed,"placeholder":_vm.placeholder},on:{"click":_vm.togglePicker,"change":function($event){return _vm.updateValue($event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }